import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgSort = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 6 10"
    ref={ref}
    {...props}
  >
    <path
      fill="#AEAEAE"
      d="M3.143 10 .668 5.714h4.95zM3.142 0l2.475 4.286H.667z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSort);
export default ForwardRef;
